import { Column } from "@ant-design/plots";

const VerticalBar = ({ data }) => {
  const config = {
    data,
    xField: "Year",
    yField: "Citations",
    xAxis: {
      label: {
        autoRotate: false,
      },
    },
    slider: {
      x: {
        values: [0.5, 1],
      },
    },
  };
  return <Column {...config} />;
};

export default VerticalBar;
